//import type { CurrencyCode } from '../../../../types';
import { defineCurrencySymbol } from '../../../../helpers';
import type { NumberSettings } from './types';
import type { PostProcessor } from '../../shared/post-processors';

/*
const currencyCodeIntlValues: Partial<Record<CurrencyCode, string>> = {
    MXN: 'MX$',
    USD: 'US$'
}
*/
export const replaceWrongCurrencyCodeBySymbol: PostProcessor<NumberSettings> = (v, { currency, hideCurrencySymbol }) => {
    // игнорируем поиск кривых валют
    // если валюты скрыты глобально (unicom)
    if (hideCurrencySymbol) {
        return v;
    }

    // фиксим косяки Intl со знаками валют
    let codeToReplace = '';

    if (v.includes(currency)) {
        codeToReplace = currency;
    }
    /*else {
        const intlValue = currencyCodeIntlValues[currency];

        if (intlValue && v.includes(intlValue)) {
            codeToReplace = intlValue;
        }
    }*/

    if (codeToReplace) {
        return v.replace(codeToReplace, defineCurrencySymbol(currency))
    }

    return v;
}
